import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React, {useEffect, useState} from 'react';
import './style.css';

interface CustomAudioPlayerProps {
  url?: string;
  timer?: number;
  theme: string;
  reseting?: boolean;
  showTime?: boolean;
  playingAction?: () => void;
}
const CustomAudioPlayer = ({
  url,
  timer,
  theme,
  reseting,
  showTime,
  playingAction,
}: CustomAudioPlayerProps) => {
  const [timerlocal, setTimerlocal] = useState<number>(0);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const [currrentProgress, setCurrrentProgress] = React.useState(0);

  const [isPlaying, setIsPlaying] = React.useState(false);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current?.pause();
      setIsPlaying(false);
    } else {
      audioRef.current?.play();
      setIsPlaying(true);
      playingAction && playingAction();
    }
  };

  const convertSeconds = (totalSeconds: number) => {
    if (!timer) return;
    const seconds =
      totalSeconds === 0
        ? Math.floor((timer / 1000) % 60)
        : Math.floor(totalSeconds % 60);

    const minutes =
      totalSeconds === 0
        ? Math.floor((timer / (1000 * 60)) % 60)
        : Math.floor((totalSeconds / 60) % 60)
            .toString()
            .padStart(2, '0');
    const hours =
      totalSeconds === 0
        ? Math.floor(timer / (1000 * 60 * 60))
        : Math.floor(totalSeconds / 3600)
            .toString()
            .padStart(2, '0');

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    if (reseting !== undefined && reseting === true && audioRef.current) {
      audioRef.current?.pause();
      setIsPlaying(false);
      audioRef.current.currentTime = 0;
    }
  }, [reseting, audioRef.current]);

  const percentage = audioRef.current?.currentTime
    ? (100 * ((audioRef.current?.currentTime || 0) - 0)) /
      (timer ? Math.floor((timer / 1000) % 60) : timerlocal)
    : 0;

  return (
    <div className="w-full flex items-center">
      <audio
        preload="auto"
        onDurationChange={e => setTimerlocal(e.currentTarget.duration)}
        className="hidden"
        ref={audioRef}
        controls
        onEnded={() => {
          setCurrrentProgress(0);
          setTimerlocal(0);
          setIsPlaying(false);
          if (audioRef.current) {
            audioRef.current.currentTime = 0;
          }
        }}
        onTimeUpdate={e => {
          setCurrrentProgress(e.currentTarget.currentTime);
          setTimerlocal(e.currentTarget.currentTime);
        }}
      >
        <source src={url} type="audio/ogg" />
      </audio>
      <div className="flex items-center w-full gap-1 audio-range-wrapper">
        {showTime && timer && (
          <div className="text-gray-900 text-lg font-Regular">
            {convertSeconds(timerlocal)}
          </div>
        )}
        <div dir="ltr" className="flex px-2 w-[90%]">
          <input
            style={{
              background: `linear-gradient(to right,${
                theme === 'green' ? ' #669F2A' : '#858A91'
              },${theme === 'green' ? ' #669F2A' : '#858A91'} ${percentage}%, ${
                theme === 'green' ? '#FFFFFF' : '#E0E3E5'
              } ${percentage + 0.1}%)`,
            }}
            step={0.05}
            type="range"
            name="progress"
            min={0}
            max={timer ? Math.floor((timer / 1000) % 60) : timerlocal}
            value={currrentProgress}
            className={classNames(
              'custom-range-slider-input',
              `${theme}-theme`,
            )}
            onChange={e => {
              if (audioRef.current) {
                audioRef.current.currentTime = e.target.valueAsNumber;
              }
            }}
          />
        </div>
        <button
          type="button"
          className={classNames(
            ' flex items-center rounded-full p-2 justify-center min-w-[35px] h-[35px]',
            {
              'bg-gray-50': theme === 'gray',
              'bg-farm-shop-100': theme === 'green',
            },
          )}
          onClick={() => togglePlayPause()}
        >
          <SpanIcon
            className={classNames('', {
              'icon-namepause1': isPlaying,
              'icon-namePlay-Right1': !isPlaying,
              'text-gray-500': theme === 'gray',
              'text-farm-shop-500': theme === 'green',
            })}
          />
        </button>
      </div>
    </div>
  );
};
CustomAudioPlayer.defaultProps = {
  theme: 'gray',
};
export default CustomAudioPlayer;
